<template>
  <div id="culture">
    <div id="culture-text">
      <h3>swamps as evil</h3>
      <h5>Cursed, haunted, and filmed with monsters</h5>
      <p>
        “Yeah, I’m back in the swamp... those gators gonna get me”
        Jim Allchin, Back in the Swamp 2011
      </p>
      <p>Throughout history, swamps have been demonized as primordial, wild and mysterious - a place that causes sickness, death and insanity, a haven for poisonous snakes man-eating alligators and wild-eyed crazies.</p>
    </div>
    <img id="mosquito" src="../assets/mosquito.svg" />
  </div>
</template>
<script>
import { select } from 'd3'
import _ from 'lodash'
export default {
  name: 'CultureSection',
  mounted() {
    this.buildContents()
  },
  components: {},
  props: ['data', 'xScale'],
  computed: {
    iFrames: function() {
      return this.data.filter(d => d.iframeSrc)
    },
    films: function() {
      return this.data.filter(d => !!d.film)
    },
  },
  methods: {
    buildContents: function() {
      select('#culture')
        .selectAll('iframe')
        .data(this.iFrames)
        .enter()
        .append('iframe')
        .attr('src', d => d.iframeSrc)
        .attr('frameborder', 0)
        .attr('allowtransparency', true)
        .attr('allow', 'encrypted-media')
        .style('left', function(d) {
          return `${_.get(d.style, 'left', 0) +
            _.get(d.style, 'adjustHorizontal', 0)}px`
        })
        .style('top', d => `${_.get(d.style, 'top') || 0}px`)

      select('#culture')
        .selectAll('.film')
        .data(this.films)
        .enter()
        .append('figure')
        .html(d => {
          return `<a href='${d.film.link}' target='_'><img src="${
            d.film.imgSrc
          }" style="width:${_.get(
            d.style,
            'width',
            163
          )}px;" /></a><figcaption>${d.film.title}, 
          ${d.year}</figcaption>`
        })
        .style('left', function(d) {
          return `${_.get(d.style, 'left', 0) +
            _.get(d.style, 'adjustHorizontal', 0)}px`
        })
        .style('top', d => `${_.get(d.style, 'top') || 0}px`)
    },
  },
}
</script>
<style>
#culture {
  position: absolute;
  left: 5425px;
  bottom: 0px;
  height: 50vh;
  width: 5500px;
  z-index: 15;
}
#culture #culture-text {
  width: 375px;
  position: absolute;
  left: 620px;
  top: 20px;
  text-align: left;
}
#culture #culture-text h3 {
  font-size: 24pt;
  margin-bottom: 5px;
  margin-top: 10px;
  color: var(--film-brown);
}
#culture #culture-text {
  margin-bottom: 5px;
  margin-top: 24px;
}
#culture #culture-text h5 {
  color: var(--film-brown);
}
#culture #culture-text p {
  font-size: 17px;
  line-height: 29px;
  font-weight: 500;
  margin-left: 30px;
}
#culture #culture-text p:first-of-type {
  font-style: italic;
}
#culture iframe {
  width: 250px;
  height: 330px;
  position: absolute;
}
#culture figure {
  position: absolute;
}

#culture figcaption {
  font-style: italic;
}
#culture #mosquito {
  width: 350px;
  position: absolute;
  top: 50px;
  left: 1460px;
}
</style>
